export default __webpack_public_path__ + "static/media/relative-mono-10-pitch-pro.a9e415a8.woff2";